import * as React from "react";
import "./index.css";
import { TextField, Grid } from "@mui/material";

interface Props {
  error: string;
  value?: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
  required?: boolean;
}

const FormTextField: React.FC<Props> = ({
  error,
  value,
  handleChange,
  name,
  label,
  required = false,
}) => {
  return (
    <Grid container sx={{ width: "100%" }}>
      <Grid size={4} display="flex" alignItems="center">
        {label}
      </Grid>
      <Grid size={8}>
        <TextField
          size="small"
          fullWidth
          value={value}
          required={required}
          id={name}
          name={name}
          onChange={handleChange}
          error={!!error}
          helperText={error}
        />
      </Grid>
    </Grid>
  );
};

export default FormTextField;
